import isEmpty from 'lodash/isEmpty'
import { Component } from 'preact'
import Elevation from 'preact-material-components/Elevation'
import CategoryItem from '../../CategoryItem'
import styles from './AvailableCategories.scss'

export default class AvailableCategories extends Component {
    state = {
        orderCounts: new Map(),
        totalPrice: 0
    }

    handleChange = categoryId => e => {
        const { categories } = this.props
        const orderCounts = new Map(this.state.orderCounts)

        const value = e.target.value

        if (value === 0) {
            orderCounts.delete(categoryId)
        } else {
            orderCounts.set(categoryId, value)
        }

        // calculating total price
        let totalPrice = 0
        orderCounts.forEach((value, key) => {
            totalPrice += categories.find(c => c.categoryId === key).price * value
        })

        this.setState({ orderCounts, totalPrice })
    }

    handleClick = () => {
        const { orderCounts, totalPrice } = this.state
        this.props.onNextClick(orderCounts, totalPrice)
    }

    convertForAvailabilitySelect = value => {
        const result = []
        for (let i = 0; i <= value; i++) {
            result.push({
                value: i,
                label: i
            })
        }
        return result
    }

    render({ categories }) {
        return (
            isEmpty(categories) || (
                <div class={styles.categoryList}>
                    {categories.map(category => (
                        <div key={category.id}>
                            <Elevation class={styles.categoryElevation} z={2}>
                                <CategoryItem category={category} />
                            </Elevation>
                        </div>
                    ))}
                </div>
            )
        )
    }
}



// WEBPACK FOOTER //
// ./components/RoomsLayout/AvailableCategories/AvailableCategories.js